import React from "react";
import {withTranslation} from "react-i18next";
import {
    ArrowRightOutlined,LeftOutlined
} from '@ant-design/icons';
import "../../tek.scss";
import {Button} from 'antd';
import {history} from '_helpers/history'

import luxs from "assets/img/LUX_SEÑALA.png";
import chronos from "assets/img/chronos/chronos-normal.png";
import Headerbutton from "../../../../component/headerButton";
import localOrSessionStore from "_helpers/localOrSessionStore";
import variables from "_constants/variables";

function stepTekThree(props) {
    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const user = JSON.parse(storage.getItem(variables.USER));
    const {t} =props;

    const saveAndContinue = () => {
        history.push("/admin/assessment")
    }
    return (

        <div className={"containerStartTekTwo wrapper history tek-portal"}>
            <div className={"insideTek boxed"}>
                <Headerbutton  saveAndContinue={saveAndContinue}  />
            </div>
            <div className={"container-history boxed"}>
                    <img className={"character character--lux character--center"} src={luxs} alt={""} />
                    <img className={"character character--chronos chronos--small character--right chronos--top"} src={chronos} alt={""} />
                <div className={"container-dialogue"}>
                    <div className={"dialogue-content-text"}>
                        <p className={"dialogue-text"} dangerouslySetInnerHTML={{__html: t('tek.itin4.misiontek1')}}></p>
                        <p className={"dialogue-text"} dangerouslySetInnerHTML={{__html: t('tek.itin4.misiontek2')}}></p>
                    </div>
                    <div className={"dialogue-buttons"}>
                        <div className="left margin-right-auto">
                            <Button
                              icon={<LeftOutlined />}
                              type={"link"}
                              onClick={() => props.goTo(2)}
                            >
                                {t("atras")}
                            </Button>
                        </div>
                        <div className="right">
                            <Button
                                    onClick={() => props.goTo(4)}
                                    type={"primary"}
                                    className="primaryButton"
                            >
                                {t("tek.itin4.accept")}
                            </Button>
                        </div>
                    </div>
                    <p className={"dialogue-name"}>
                        <strong>LUX</strong>
                    </p>
                </div>
            </div>
        </div>

    )
}

export default withTranslation()(stepTekThree);
